<template>
  <div id="page-container">
    <el-container style="height: 500px; border: 1px solid #eee">
      <el-aside class="hiden_menu" :class="showMenu?'show_menu':'is_hiden_menu'" width="200px"
        style="background-color: rgb(238, 241, 246)">
        <Menu v-if="$route.name != 'Login'" ref="Menu"></Menu>
      </el-aside>
      <el-container>
        <el-header style="text-align: right; font-size: 12px">
          <Header v-if="$route.name != 'Login'" ref="Header"></Header>
        </el-header>
        <el-main>
          <div style="background-color:#F2F4F9;">
            <router-view :key="$route.fullPath"></router-view>
          </div>
        </el-main>
      </el-container>
    </el-container>

    <main id="main-container" :class="{none: $route.name == 'Login' }"></main>
  </div>
</template>

<script>
  import Header from "./Header";
  import Menu from "./Menu";
  import Util from "../Util.js";
  export default {
    name: "Panel",
    components: {
      Header,
      Menu
    },
    data() {
      return {

      };
    },
    computed: {
      showMenu() {
        return this.$store.state.showMenu;
      },
    },
    watch: {},
    mounted() {},
    methods: {}
  };

</script>

<style lang="less" scoped>
  .show_menu {
    display: block;
  }
   .is_hiden_menu {
    display: none;
  }

  #page-container {
    overflow-x: auto;
  }

  .el-container {
    border: none !important;
    height: 100vh !important;
  }

  .el-main {
    background: rgb(238, 241, 246);
  }

</style>



// WEBPACK FOOTER //
// src/components/Panel.vue